import React from "react";
import styles from "./TableStyles.module.scss";

function isTruthyFlag(value) {
  return value === 1 || value === "1" || value === true;
}

export function isRideCanceled(ride) {
  return isTruthyFlag(ride?.canceled);
}

export function parseRideFinishedAt(value) {
  if (!value || typeof value !== "string") return null;
  if (value.startsWith("0000-00-00")) return null;

  const trimmed = value.trim();
  const hasTimezone = /([zZ]|[+-]\d{2}:\d{2})$/.test(trimmed);
  const normalized = hasTimezone ? trimmed : `${trimmed.replace(" ", "T")}Z`;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function isRideFinishedOrCanceled(ride) {
  return Boolean(ride?.canceled || ride?.finished);
}

export function isScheduledRide(ride) {
  const scheduled = ride?.scheduled;
  return scheduled === 1 || scheduled === "1" || scheduled === true;
}

export function getRideLabel(ride) {
  const {
    canceled,
    finished,
    arrived,
    accepted,
    confirmed,
    scheduled,
    payment_status,
    scheduled_activated,
  } = ride || {};

  const confirmValue = isTruthyFlag(confirmed);
  const scheduledValue = isTruthyFlag(scheduled);
  const scheduledActivatedValue = isTruthyFlag(scheduled_activated);

  if (canceled && finished) {
    return (
      <span className={styles.tagStatus} style={{ color: "#d9534f" }}>
        BAD
      </span>
    );
  }

  if (canceled) {
    return (
      <span className={styles.tagStatus} style={{ color: payment_status !== "paid" ? "#d9534f" : "#f0ad4e" }}>
        CANCELED
      </span>
    );
  }

  if (finished) {
    return (
      <span className={styles.tagStatus} style={{ color: "#5cb85c" }}>
        FINISHED
      </span>
    );
  }

  if (arrived) {
    return (
      <span className={styles.tagStatus} style={{ color: "#337ab7" }}>
        IN SERVICE
      </span>
    );
  }

  if (scheduledValue && !confirmValue && !scheduledActivatedValue) {
    return (
      <span className={styles.tagStatus} style={{ color: "#e0b84f" }}>
        SEARCHING
      </span>
    );
  }
  if (scheduledValue && confirmValue && !scheduledActivatedValue) {
    return (
      <span className={styles.tagStatus} style={{ color: "#e0b84f" }}>
        UPCOMING
      </span>
    );
  }

  if (accepted) {
    return (
      <span className={styles.tagStatus} style={{ color: "#f0ad4e" }}>
        ARRIVING
      </span>
    );
  }

  if (!accepted && !confirmValue && !arrived) {
    return (
      <span className={styles.tagStatus} style={{ color: "gray" }}>
        SEARCHING
      </span>
    );
  }

  return null;
}
